import { render } from "./LearnerProfilePage.vue?vue&type=template&id=7a793c0e&scoped=true"
import script from "./LearnerProfilePage.vue?vue&type=script&lang=js"
export * from "./LearnerProfilePage.vue?vue&type=script&lang=js"

import "./LearnerProfilePage.vue?vue&type=style&index=0&id=7a793c0e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a793c0e"]])

export default __exports__